import React, { useContext, useState, useEffect, useMemo } from 'react';
import { $Global } from '../../App';
import { RouteComponentProps, withRouter } from 'react-router';
import { deviceType } from 'react-device-detect';
import { PacmanLoader } from 'react-spinners';
import { Parallax, useController } from 'react-scroll-parallax';
import { Footer } from '../../Components/Footer/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faJsSquare,
  faCss3,
  faSass,
  faReact
} from '@fortawesome/free-brands-svg-icons';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import * as firebase from 'firebase';
import cls from 'classnames';
import monent from 'moment';
// asset
import './Home.scss';
import { Photo_PC, Photo_Mobile } from '../../Resource/Tools/function/ImgAsset';

const __Home: React.FC<RouteComponentProps> = props => {
  const { global, setGlobal } = useContext($Global);
  const [isInit, setIsInit] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 992);
  const [info, setInfo] = useState<ApiPersonalInfo.PersonalInfo>(null);
  const [exp, setExp] = useState<ApiExperience.Experience>([]);
  const [tooltip, setTooltip] = useState<boolean>(false);
  // connect to firebase
  useEffect(() => {
    const handle = async () => {
      const db = firebase.firestore();
      // get personal info
      const getPersonalInfo = db
        .collection('personal_info')
        .get()
        .then(res => {
          res.forEach(doc => {
            if (doc.id === 'eofGwuZucAff5dvvw4vY')
              return setInfo(
                curr => doc.data() as ApiPersonalInfo.PersonalInfo
              );
          });
        });
      // get exp
      const getExp = db
        .collection('experience')
        .get()
        .then(res => {
          res.forEach(doc => {
            if (doc.id === 'list') {
              let { exp } = doc.data();
              setExp(curr => {
                exp.reduce(
                  (
                    prev: ApiExperience.Company[],
                    curr: ApiExperience.Company
                  ) => {
                    if (curr.projects) {
                      let newData = {
                        ...curr,
                        projects: curr.projects.map(e => ({
                          ...e,
                          show: false
                        }))
                      };
                      return [...prev];
                    }
                  },
                  []
                );
                return exp as ApiExperience.Experience;
              });
            }
          });
        });
      const personalInfo = await getPersonalInfo;
      const exp = await getExp;
      setIsInit(true);
    };
    handle();
  }, []);

  // resize
  useEffect(() => {
    let __isMobile = window.innerWidth < 992;
    const onResize = function(e: UIEvent) {
      if (__isMobile) return setIsMobile(__isMobile);
      if (!__isMobile) return setIsMobile(!__isMobile);
    };
    window.addEventListener('resize', onResize);
    console.log(navigator.language, 'lang');
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);
  
  // fix resize
  useController().parallaxController.update();
  // 計算累積經驗時數
  const caculateExpTime = useMemo(() => {
    console.log(monent().valueOf())
    if (exp && exp.length > 0) {
      let totalSec = exp.reduce((val, comp: ApiExperience.Company) => {
        const { startTime, endTime } = comp;
        let eachTotalTime = monent(endTime ? endTime.seconds : monent().valueOf() / 1000).diff(startTime.seconds);
        return val + eachTotalTime;
      }, 0);

      const middlePoint = Math.floor(totalSec / 60 / 60 / 24 / 365);
      return middlePoint >= (middlePoint + 0.5) ? `${middlePoint}年半` : `${middlePoint}年`;
    }
  }, [exp]);
  // match the icon
  const matchIcon = (arg: string) => {
    arg = arg.toLocaleLowerCase();
    switch (arg) {
      case 'html':
        return (
          <span className="mr-3">
            <FontAwesomeIcon icon={faCode} />
          </span>
        );
      case 'css/scss':
        return (
          <span className="mr-3">
            <FontAwesomeIcon icon={faCss3} />
          </span>
        );
      case 'scss/sass':
        return (
          <span className="mr-3">
            <FontAwesomeIcon icon={faSass} />
          </span>
        );
      case 'js':
        return (
          <span className="mr-3">
            <FontAwesomeIcon icon={faJsSquare} />
          </span>
        );
      case 'javascript':
        return (
          <span className="mr-3">
            <FontAwesomeIcon icon={faJsSquare} />
          </span>
        );
      case 'ts':
        return <span className="mr-3">{'{TS}'}</span>;
      case 'typescript':
        return <span className="mr-3">{'{TS}'}</span>;
      case 'react':
        return (
          <span className="mr-3">
            <FontAwesomeIcon icon={faReact} />
          </span>
        );
      case 'react.js':
        return (
          <span className="mr-3">
            <FontAwesomeIcon icon={faReact} />
          </span>
        );
    }
  };
  // Loading component
  if (!isInit || !info || !exp) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <PacmanLoader size={50} color={'#4782E0'} loading={true} />
      </div>
    );
  }

  return (
    <div className="wrap">
      {/* <Header></Header>*/}
      <section>
        <div className="info">
          <div>
            {(() => {
              if (isMobile) {
                return (
                  <>
                    <div className="info__subtitle">
                      {info.title.toUpperCase()}
                    </div>
                    <div className="info__title">
                      {`${info.enName.toUpperCase()} ${info.firstName.toUpperCase()}`}
                    </div>
                  </>
                );
              }
                return (
                  <Parallax x={['60', '-60']}>
                    <div className="info__subtitle">
                      {info.title.toUpperCase()}
                    </div>
                    <div className="info__title">
                      {`${info.enName.toUpperCase()} ${info.firstName.toUpperCase()}`}
                    </div>
                  </Parallax>
                );
            })()}
          </div>
          <div
            style={{ position: 'relative' }}
            onMouseOver={() => {
              setTooltip(true);
            }}
            onMouseLeave={() => setTooltip(false)}
          >
            {(() => {
              if (isMobile)
                return (
                  <>
                    <div
                      className={cls('tooltip', tooltip ? 'tooltip_show' : '')}
                    >
                      <div className="tooltip__content">
                        {(() => {
                          const res = Math.floor(
                            Math.random() * info.greeting.length
                          );
                          return info.greeting[res].response;
                        })()}
                        !
                      </div>
                      <i></i>
                    </div>
                    <div className="info__photo">
                      <img
                        src={deviceType === 'mobile' ? Photo_Mobile : Photo_PC}
                        // src="https://www.nicknotas.com/wp-content/uploads/2018/07/Guy_Duck_Face.jpg"
                        alt=""
                      />
                      <div className="info__photo__frame"></div>
                      <div className="info__photo__frame2"></div>
                    </div>
                  </>
                );
              if (!isMobile)
                return (
                  <Parallax x={['-300px', '300px']} tagOuter="div">
                    <div
                      className={cls('tooltip', tooltip ? 'tooltip_show' : '')}
                    >
                      <div className="tooltip__content">
                        {(() => {
                          const res = Math.floor(
                            Math.random() * info.greeting.length
                          );
                          return info.greeting[res].response;
                        })()}
                        !
                      </div>
                      <i></i>
                    </div>
                    <div className="info__photo">
                      <img
                        src={deviceType === 'mobile' ? Photo_Mobile : Photo_PC}
                        // src="https://www.nicknotas.com/wp-content/uploads/2018/07/Guy_Duck_Face.jpg"
                        alt=""
                      />
                      <div className="info__photo__frame"></div>
                      <div className="info__photo__frame2"></div>
                    </div>
                  </Parallax>
                );
            })()}
          </div>
          <div className="mouse"></div>
          <div className="bg">
            <div className="bg__left">
              <Parallax y={['60', '-60']}>
                <svg viewBox="0 0 15 10">
                  <path d="M3 9 L3 1 L4 1 L7 7.5 L10 1 L11 1 L11 9"></path>
                  <path d="M15 .5 L15 9"></path>
                </svg>
              </Parallax>
            </div>
            <div className="bg__right">
              <Parallax y={['-60', '60']}>
                <svg viewBox="0 0 15 10">
                  <path d="M0 .5 L0 9"></path>
                  <path d="M4 9 L4 1 L5 1 L9 8.5 L10 8.5 L10 .5"></path>
                </svg>
              </Parallax>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="contain">
          <div className="contain__title">About</div>
          <p className="background">
            Hi! 我叫
            <a
              data-text={info.enName}
              className="text_important background__link"
              onClick={() => window.open(info.resumeAddress, 'blank')}
            >
              {info.enName}
            </a>
            ，一名前端工程師，目前累計資歷{caculateExpTime}以上，喜歡
            <span className="text_delete">被迫</span>
            學習新技術活用於開發專案，並且與他人討論技術及實用的做法，另外也有些許的Photoshop修圖技術
            <span className="text_delete">惡搞合成圖片</span>，以及繪製簡易SVG
            icon。
          </p>
        </div>
      </section>
      <section>
        <div className="contain">
          <div className="contain__title">Skills</div>
          <div className="skills">
            {info.skills.map(e => (
              <div className="skills__li" data-text={e} key={e}>
                {matchIcon(e)}
                {e}
              </div>
            ))}
          </div>
        </div>
      </section>
      <section>
        <div className="contain">
          <div className="contain__title">Experience</div>
          <div className="exp">
            <div>
              {exp &&
                exp
                  .filter(e => e.projects && e.projects.length > 0)
                  .map((e, eIndex) => (
                    <div className="exp__item" key={e.coName + e.endTime}>
                      <p>
                        {e.coName}&nbsp; &nbsp;
                        {monent(e.startTime.seconds * 1000).format(
                          'YYYY/MM/DD'
                        )}
                      </p>
                      <ul>
                        {e.projects &&
                          e.projects.map((f, fIndex) => {
                            return (
                              <div className="exp__list" key={fIndex}>
                                <div className="exp__title">
                                  <div className="exp__title__num">
                                    {e.projects && e.projects.length > 1
                                      ? fIndex + 1 + '.'
                                      : ''}
                                  </div>
                                  {f.title}
                                </div>
                                <div className="exp__des">{f.description}</div>
                              </div>
                            );
                          })}
                      </ul>
                    </div>
                  ))}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export const Home = withRouter(__Home);
